import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../components/ui/button";
import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Dialog,
} from "../../../../components/ui/dialog";

import { navLocale } from "../../../../lib/locale";
import { TError } from "../../../../types/error";

interface UnprocessableContentErrorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  error: any;
  setError: (error: TError) => void;
}

export function UnprocessableContentErrorDialog({
  open,
  onOpenChange,
  error,
  setError,
}: UnprocessableContentErrorDialogProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRedirect = () => {
    onOpenChange(false);
    setError(null);
    navigate(navLocale("/data-manager"));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-[460px] rounded-xl border border-gray-100 dark:border-white/10"
        onInteractOutside={(e) => e.preventDefault()}
        onOpenAutoFocus={(e) => e.preventDefault()}
        hideCloseButton={true}
      >
        <div className="flex flex-col grow-0 gap-y-5">
          <DialogHeader>
            <DialogTitle>{t("shared-422-error-title")}</DialogTitle>
            <DialogDescription>
              {t("shared-422-error-caption")}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button
              className="flex flex-row h-8 px-3 items-center rounded-lg text-xs text-white bg-[#0195c5] hover:bg-[#0195c5]/80"
              onClick={handleRedirect}
              variant="headless"
              size="headless"
              type="button"
            >
              {t("shared-422-error-submit")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
